import {
	createSlice,
	createEntityAdapter,
	createAsyncThunk,
	createSelector,
} from "@reduxjs/toolkit";
import {
	getAttachmentsByFormId,
	getCMEAttachmentById,
	postAttachment as post,
} from "api";
import { downloadFile } from "utils/common";

export const fetchAttachmentById = createAsyncThunk(
	"cmeAttachments/fetchAttachmentById",
	//need the thunkApi's getState to retrieve auth token
	async (attachmentId, { rejectWithValue, dispatch }) => {
		try {
			downloadFile(await getCMEAttachmentById({ attachmentId }));
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const fetchAttachmentByFormId = createAsyncThunk(
	"cmeAttachments/fetchAttachmentByFormId",
	//need the thunkApi's getState to retrieve auth token
	async (formId, { rejectWithValue, dispatch }) => {
		try {
			const data = await getAttachmentsByFormId({ formId });
			dispatch(attachmentReceived(data));
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const postAttachment = createAsyncThunk(
	"cmeAttachments/postAttachment",
	async (data, { dispatch, rejectWithValue }) => {
		try {
			const response = await post(data);
			dispatch(attachmentReceived(response));
			return response;
		} catch (error) {
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const attachmentAdapter = createEntityAdapter({
	selectId: (attachment) => attachment.attachmentId,
});

export const ATTACHMENT_LINE_TEMPLATE = {
	attachmentId: 0,
	formId: 0,
	lineId: 0,
	fileName: null,
	fileContent: null,
	fileType: null,
	fileId: null,
	fileLink: null,
	isDeleted: false,
};

const initialState = attachmentAdapter.getInitialState({
	status: "idle",
	error: null,
});

const attachmentSlice = createSlice({
	name: "cmeAttachments",
	initialState,
	reducers: {
		attachmentReceived(state, action) {
			attachmentAdapter.setAll(state, action.payload);
		},
		attachmentUpserted(state, action) {
			if (action.payload.isDeleted) {
				attachmentAdapter.removeOne(state, action.payload.attachmentId);
			} else {
				attachmentAdapter.upsertOne(state, action);
			}
		},
	},
	extraReducers: {
		RESET_CME: (state, action) => {
			return initialState;
		},
		[postAttachment.pending]: (state, action) => {
			state.status = "loading";
		},
		[postAttachment.fulfilled]: (state, action) => {
			state.status = "idle";
		},
		[postAttachment.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
		[fetchAttachmentById.pending]: (state, action) => {
			state.status = "loading";
		},
		[fetchAttachmentById.fulfilled]: (state, action) => {
			state.status = "idle";
		},
		[fetchAttachmentById.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
	},
});

export const { attachmentReceived, attachmentUpserted } =
	attachmentSlice.actions;

export const {
	selectAll: selectAllAttachment,
	selectIds: selectAttachmentIds,
	selectById: selectAttachmentById,
} = attachmentAdapter.getSelectors((state) => state?.cme?.attachments);

export const createSelectAttachmentByRequestId = (requestId) => {
	return createSelector([selectAllAttachment], (attachments) => {
		return attachments.filter((a) => a.lineId === requestId);
	});
};

export default attachmentSlice.reducer;
